








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DAP_ROUTES } from '@/modules/dap/router';

@Component
export default class WizardProgress extends Vue {
  public DAP_ROUTES = DAP_ROUTES;
  @Prop({ default: 1 }) step: number;
  @Prop({ default: 1 }) wizard: number;
  @Prop({ default: false }) isEditProject: false;

  public get projectId () {
    return this.$route.params.projectId;
  }

  public get dapId () {
    return this.$route.params.dapId;
  }

  get totalColumns () {
    switch (this.wizard) {
      case 1: return 'four';
      case 2: return 'three';
      case 3: return 'two';
      case 4: return 'one';
      default: return '';
    }
  }
}
